import { config } from "JS/Config";
import { appConstants } from "JS/Helpers/Constants";
import { ChecklistItem } from "JS/Models/Checklist";
import { BaseService } from "../BaseService";

export class ChecklistService extends BaseService {
    getChecklistItems = () =>
        this.ngCall<ChecklistItem[]>(
            "get",
            appConstants.ngEndpoints.getChecklistItems(config.user.memberId),
        );

    checkChecklistItem = (itemNumber: string) =>
        this.ngCall(
            "put",
            appConstants.ngEndpoints.checkChecklistItem(
                config.user.memberId,
                itemNumber,
            ),
        );
}
